import React, { useState } from "react";
import { Card, Tabs } from "antd";
import List from './list/List';
import Add from './add/Add';
const TabPane = Tabs.TabPane;


const ProjectsPage = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [ProjectsEditData, setProjectsEditData] = useState(null);
  const [ProjectsEditFlag, setProjectsEditFlag] = useState(false);
  const callback = (key, data = null, currentPage = 1) => {
    setActiveTab(key);
    if (data && key === "2") {
      setProjectsEditData(data);
      setProjectsEditFlag(true);
    } else if (key === "2") {
      setProjectsEditFlag(false);
      setProjectsEditData(null);
    }
  };

  return (
    <Card className="gx-card" title="پروژه ها">
      <Tabs activeKey={activeTab} onChange={callback}>
        <TabPane tab="لیست پروژه ها" key="1">
          <List changeTabEvent={callback} />
        </TabPane>
        <TabPane tab="افزودن / ویرایش پروژه ها" key="2">
          <Add fields={ProjectsEditData} editSection={ProjectsEditFlag} changeTabEvent={callback} />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default ProjectsPage;
